import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--submit-gate"
//
// Keeps a submit button disabled until a choice is made — the Site Invoicing
// tab's link drawer (a search result picked) and new-titular picker (a Site
// chosen), exactly as React's LinkBillingAccountDrawer / PickNewMainModal do.
// This deliberately departs from the "no disabled submit buttons" rule in
// CLAUDE.md: the user chose React parity here (user decision, CONEK-8263).
//
// `selector` matches the element that proves a choice was made; the button is
// enabled while it matches. Wire `update` to whatever can change the choice
// (change events, a results frame re-render, a drawer reset).
export default class extends Controller {
  static targets = ["button"]
  static values = { selector: String }

  connect() {
    this.update()
  }

  update() {
    const chosen = this.element.querySelector(this.selectorValue) !== null
    this.buttonTargets.forEach((button) => {
      button.disabled = !chosen
      button.setAttribute("aria-disabled", String(!chosen))
    })
  }
}
